<template>
  <div class="about container-fluid p-0">

    <!-- Top spacing + Back to Home -->
    <section class="container topbar">
      <router-link
        class="ghost-btn"
        :to="{ name: 'Home' }"
        aria-label="Back to Home"
      >
        <i class="bi bi-arrow-left"></i>
        <span>Home</span>
      </router-link>
    </section>

    <!-- INTRO -->
    <section class="container">
      <div class="intro mx-auto">
        <h2 class="h4 fw-bold text-maroon text-center mb-3">Our Mission</h2>
        <p class="intro__text">
          Gopher Housing, a project initiated by University of Minnesota – Twin Cities students,
          aims to provide incoming residents with valuable insights from current residents.
        </p>
      </div>
    </section>

    <!-- TEAM -->
    <section class="container pb-5">
      <h3 class="section-title text-center text-maroon fw-bold">Our Team</h3>

      <div class="team-grid">
        <!-- Jonathan -->
        <article class="person-card hover-lift">
          <figure class="person-media">
            <img
              :src="require('@/img/gallery/Jonathan.jpg')"
              width="240"
              height="320"
              alt="Jonathan Paraschou"
              class="person-img"
            />
            <figcaption class="person-overlay">
              <div class="social">
                <a href="https://www.linkedin.com/in/jonathan-paraschou/" class="social-link" aria-label="LinkedIn">
                  <font-awesome-icon icon="fa-brands fa-linkedin" />
                </a>
                <a href="https://www.instagram.com/jonathan.paraschou/" class="social-link" aria-label="Instagram">
                  <font-awesome-icon icon="fa-brands fa-instagram" />
                </a>
                <a href="https://github.com/JonathanParaschou" class="social-link" aria-label="GitHub">
                  <font-awesome-icon icon="fa-brands fa-github" />
                </a>
              </div>
            </figcaption>
          </figure>
          <div class="person-meta text-center">
            <div class="person-name">Jonathan Paraschou</div>
            <div class="person-role">Software Engineer</div>
          </div>
        </article>

        <!-- Sammer -->
        <article class="person-card hover-lift">
          <figure class="person-media">
            <img
              :src="require('@/img/gallery/Sammer.jpg')"
              width="240"
              height="320"
              alt="Sammer Hassan"
              class="person-img"
            />
            <figcaption class="person-overlay">
              <div class="social">
                <a href="https://www.linkedin.com/in/sammer-hassan-047471221/" class="social-link" aria-label="LinkedIn">
                  <font-awesome-icon icon="fa-brands fa-linkedin" />
                </a>
                <a href="https://github.com/oDzzy" class="social-link" aria-label="GitHub">
                  <font-awesome-icon icon="fa-brands fa-github" />
                </a>
                <a href="https://instagram.com/samhassan_12" class="social-link" aria-label="Instagram">
                  <font-awesome-icon icon="fa-brands fa-instagram" />
                </a>
              </div>
            </figcaption>
          </figure>
          <div class="person-meta text-center">
            <div class="person-name">Sammer Hassan</div>
            <div class="person-role">Software Engineer</div>
          </div>
        </article>

        <!-- Christian -->
        <article class="person-card hover-lift">
          <figure class="person-media">
            <img
              :src="require('@/img/gallery/Christian.jpg')"
              width="240"
              height="320"
              alt="Christian Golish"
              class="person-img"
            />
            <figcaption class="person-overlay">
              <div class="social">
                <a href="https://www.linkedin.com/in/christian-golish-70b70622a/" class="social-link" aria-label="LinkedIn">
                  <font-awesome-icon icon="fa-brands fa-linkedin" />
                </a>
              </div>
            </figcaption>
          </figure>
          <div class="person-meta text-center">
            <div class="person-name">Christian Golish</div>
            <div class="person-role">Software Engineer</div>
          </div>
        </article>

        <!-- Cole -->
        <article class="person-card hover-lift">
          <figure class="person-media">
            <img
              :src="require('@/img/gallery/Cole.jpg')"
              width="240"
              height="320"
              alt="Cole Garcia"
              class="person-img"
            />
            <figcaption class="person-overlay">
              <div class="social">
                <a href="https://www.instagram.com/cole_.g/" class="social-link" aria-label="Instagram">
                  <font-awesome-icon icon="fa-brands fa-instagram" />
                </a>
                <a href="https://www.linkedin.com/in/cole-garcia-aa7a40189/" class="social-link" aria-label="LinkedIn">
                  <font-awesome-icon icon="fa-brands fa-linkedin" />
                </a>
              </div>
            </figcaption>
          </figure>
          <div class="person-meta text-center">
            <div class="person-name">Cole Garcia</div>
            <div class="person-role">Graphic Designer</div>
          </div>
        </article>

        <!-- Louis -->
        <article class="person-card hover-lift">
          <figure class="person-media">
            <img
              :src="require('@/img/gallery/Louis.jpg')"
              width="240"
              height="320"
              alt="Louis Schwab"
              class="person-img"
            />
            <figcaption class="person-overlay">
              <div class="social">
                <a href="https://www.linkedin.com/in/best-applicant/" class="social-link" aria-label="LinkedIn">
                  <font-awesome-icon icon="fa-brands fa-linkedin" />
                </a>
              </div>
            </figcaption>
          </figure>
          <div class="person-meta text-center">
            <div class="person-name">Louis Schwab</div>
            <div class="person-role">Marketing Specialist</div>
          </div>
        </article>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: "About",
};
</script>

<style>
@import "https://cdn.jsdelivr.net/npm/bootstrap-icons/font/bootstrap-icons.css";

/* THEME TOKENS (match Home) */
:root {
  --gh-maroon: #7a0019;
  --gh-gold: #ffcc33;
  --gh-ink: #1f1f1f;
  --gh-muted: rgba(0, 0, 0, 0.55);
  --gh-card: #f7f7f8;
  --gh-radius: 18px;
}

/* UTIL */
.text-maroon { color: var(--gh-maroon); }
.text-white-75 { color: rgba(255, 255, 255, 0.85); }
.hover-lift { transition: transform .18s ease, box-shadow .18s ease; }
.hover-lift:hover { transform: translateY(-2px); }

/* Topbar spacing + back button */
.topbar {
  padding-top: 18px;
  padding-bottom: 6px;
  display: flex;
  justify-content: flex-start;
}
@media (min-width: 768px) {
  .topbar { padding-top: 24px; }
}
.ghost-btn {
  display: inline-flex;
  align-items: center;
  gap: .5rem;
  padding: .5rem .9rem;
  border-radius: 999px;
  text-decoration: none;
  font-weight: 600;
  color: var(--gh-maroon);
  background: #ffffff;
  border: 1px solid rgba(122, 0, 25, 0.25);
  box-shadow: 0 1px 4px rgba(0,0,0,.04);
  transition: all .18s ease;
}
.ghost-btn i { font-size: 1.05rem; line-height: 1; }
.ghost-btn:hover {
  background: rgba(122, 0, 25, 0.06);
  border-color: var(--gh-maroon);
  transform: translateY(-1px);
}

/* INTRO */
.intro {
  max-width: 920px;
  background: linear-gradient(180deg, #fff9f9, #fff6f6);
  border: 1px solid rgba(122, 0, 25, 0.12);
  border-radius: 16px;
  padding: 1.25rem 1.5rem;
  margin: 0 auto 1.75rem;
  box-shadow: 0 2px 10px rgba(0,0,0,.03);
}
.intro__text {
  color: var(--gh-ink);
  margin: 0;
  text-align: center;
  line-height: 1.6;
}

/* SECTION TITLE */
.section-title {
  font-size: 1.75rem;
  margin: 1.75rem 0 1.25rem;
}

/* TEAM GRID */
.team-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: clamp(16px, 2vw, 24px);
}
@media (max-width: 1200px) {
  .team-grid { grid-template-columns: repeat(3, 1fr); }
}
@media (max-width: 768px) {
  .team-grid { grid-template-columns: repeat(2, 1fr); }
}
@media (max-width: 520px) {
  .team-grid { grid-template-columns: 1fr; }
}

/* PERSON CARD */
.person-card {
  background: var(--gh-card);
  border: 1px solid rgba(0,0,0,.06);
  border-radius: var(--gh-radius);
  overflow: hidden;
  box-shadow: 0 1px 1px rgba(0,0,0,.04), 0 6px 18px rgba(0,0,0,.05);
}

.person-media {
  position: relative;
  margin: 0;
  aspect-ratio: 3 / 4;
  background: #f1f1f1;
}
.person-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.person-overlay {
  position: absolute; inset: 0;
  display: grid;
  place-items: center;
  background: linear-gradient(to bottom, rgba(122,0,25,0.0), rgba(122,0,25,0.55));
  opacity: 0;
  transition: opacity .2s ease;
}
.person-card:hover .person-overlay { opacity: 1; }

.social {
  display: inline-flex;
  gap: 12px;
  padding: 10px 14px;
  border-radius: 999px;
  background: rgba(255,255,255,.2);
  border: 1px solid rgba(255,255,255,.5);
  backdrop-filter: blur(6px);
}
.social-link {
  display: grid; place-items: center;
  width: 38px; height: 38px;
  border-radius: 50%;
  color: #fff; text-decoration: none;
  transition: transform .15s ease, background .15s ease, color .15s ease;
}
.social-link:hover {
  transform: translateY(-1px);
  background: rgba(255,255,255,.15);
  color: var(--gh-gold);
}

.person-meta { padding: .85rem 1rem 1.1rem; }
.person-name {
  font-weight: 700;
  font-size: 1.05rem;
  color: var(--gh-ink);
}
.person-role {
  color: var(--gh-maroon);
  font-weight: 600;
  font-size: .95rem;
}

/* CTA CARD (kept for future partner/CTA use) */
.cta-card {
  background: #fff;
  border: 1px solid rgba(0,0,0,.06);
  border-radius: 14px;
  padding: 1.25rem 1rem 1.4rem;
  max-width: 520px;
  box-shadow: 0 1px 1px rgba(0,0,0,.04), 0 6px 18px rgba(0,0,0,.05);
}
.cta-link { text-decoration: none; color: inherit; display: inline-block; }
.cta-logo {
  display: block;
  margin: 0 auto .5rem;
  border-radius: 12px;
  box-shadow: 0 8px 22px rgba(0,0,0,.08);
}
.cta-caption {
  font-weight: 700;
  color: var(--gh-maroon);
}

/* Legacy utility retained */
.nice-boxshadow {
  -webkit-box-shadow: 0 1px 1px hsl(0deg 0% 0% / 0.075), 0 2px 2px hsl(0deg 0% 0% / 0.075),
    0 4px 4px hsl(0deg 0% 0% / 0.075), 0 8px 8px hsl(0deg 0% 0% / 0.075),
    0 16px 16px hsl(0deg 0% 0% / 0.075);
  box-shadow: 0 1px 1px hsl(0deg 0% 0% / 0.075), 0 2px 2px hsl(0deg 0% 0% / 0.075),
    0 4px 4px hsl(0deg 0% 0% / 0.075), 0 8px 8px hsl(0deg 0% 0% / 0.075),
    0 16px 16px hsl(0deg 0% 0% / 0.075);
}
</style>
